import { render, staticRenderFns } from "./layoutVertical.vue?vue&type=template&id=0f9705f1&"
import script from "./layoutVertical.vue?vue&type=script&lang=js&"
export * from "./layoutVertical.vue?vue&type=script&lang=js&"
import style0 from "./layoutVertical.vue?vue&type=style&index=0&id=0f9705f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports